(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ModalEditContagemCtrl', ModalEditContagemController);

  ModalEditContagemController.$inject = [
    '$scope',
    'objeto',
    'LoadingService',
    'ContagensService',
    '$q',
    'MessagesService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function ModalEditContagemController($scope, objeto, LoadingService, ContagensService,
    $q, MessagesService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.data = {
      comprimento: null,
      distancia: null
    };

    //////////////////////////////////////////
    // Bindable functions
    vm.save = save;
    vm.canSave = canSave;

    //////////////////////////////////////////
    // Function declarations

    function save() {
      LoadingService.showLoading();
      return ContagensService
        .changeStandConfigurations(vm.data)
        .then(() => {
          MessagesService.alert('Registro salvo com sucesso!');
          $scope.$close(true);
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível salvar o registro. Verifique os dados e tente novamente.');
        })
        .finally(LoadingService.hideLoading);
    }

    function canSave() {
      return $scope.contagemForm.$valid;
    }

    //////////////////////////////////////////
    // Controller logic
    const sincId = objeto.sincObjectId || objeto.sincId;
    vm.data = {
      id: sincId,
      comprimento: parseFloat(objeto.configuration.lines_length),
      distancia: objeto.configuration.lines_distance
    };
  }
}());
